// test1823
(1823 && 0);
